import { render, staticRenderFns } from "./orderHistoryIndex.vue?vue&type=template&id=d1b62242&"
import script from "./orderHistoryIndex.vue?vue&type=script&lang=js&"
export * from "./orderHistoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports